import React from 'react'
import isNull from 'lodash/isNull'
import { compose, withProps, withState, branch, renderNothing, defaultProps } from 'recompose'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import {
  createElement,
  createRootElement,
  openSelector,
  closeSelector,
  overElement,
  selectElement,
  deleteElement,
  deleteRootElement,
  switchDown,
  switchUp,
  switchRootDown,
  switchRootUp,
  addTemplateToElement,
  addTemplateToRoot,
} from './actions'
import {
  selectElementSelector,
  selectOverElementId,
  selectSelectedId,
} from './selectors'

export const withCanvasActions = () => compose(
  defaultProps({
    emptyMode: false,
  }),
  connect(
    (state) => ({
      elementSelector: selectElementSelector(state),
      currentParentId: selectSelectedId(state),
    }),
    (dispatch) => (
      bindActionCreators({
        createElement,
        createRootElement,
        openSelector,
        closeSelector,
        addTemplateToElement,
        addTemplateToRoot,
      }, dispatch)
    ),
  ),
  branch(
    ({
      refElement,
      emptyMode,
      currentParentId,
      parentId,
      upperParentId,
    }) => {
      if(isNull(refElement) && !emptyMode && isNull(parentId) && !isNull(currentParentId)) {
        // for root canvas
        return true
      } else if (emptyMode) {
        return false
      } else if (isNull(currentParentId) && !isNull(parentId)) {
        return true
      }
      return (
        currentParentId !== parentId &&
        currentParentId !== upperParentId // for display dot Button in COLUMN
      )
    },
    renderNothing
  ),
  withProps(
    ({
      parentId,
      emptyMode,
      elementIndex,
      createElement,
      createRootElement,
      selectorId,
      elementSelector,
      openSelector,
      addTemplateToElement,
      addTemplateToRoot,
    }) => {
      return {
        isOpened: selectorId === elementSelector,
        openSelector: (e) => {
          e.stopPropagation()
          return openSelector(selectorId)
        },
        onCreateElement: (element) => {
          return parentId ? createElement({
            element,
            parentId,
            addToIndex: elementIndex,
          })
            : createRootElement(
              element,
              elementIndex,
            )
        },
        onAddTemplate: (template) => {
          return parentId ?
            addTemplateToElement({
              parentId,
              template,
              addToIndex: elementIndex,
            })
            :
            addTemplateToRoot(template, elementIndex)
        },
        zIndex: emptyMode && !parentId ? 999 : 1001
      }
    },
  ),
)

export const withElementActions = () => compose(
  connect(
    (state) => ({
      overElementId: selectOverElementId(state),
      selectedId: selectSelectedId(state),
    }),
    (dispatch) => (
      bindActionCreators({
        overElement,
        selectElement,
        deleteElement,
        deleteRootElement,
        switchDown,
        switchUp,
        switchRootDown,
        switchRootUp,
      }, dispatch)
    ),
  ),
  withState('showParents', 'setShowParents', false),
  withProps(
    ({
      parentId,
      elementId,
      selectedId,
      overElementId,
      parents = [],
      showParents,
      setShowParents,

      // redux actions
      overElement,
      selectElement,
      deleteElement,
      deleteRootElement,
      switchDown,
      switchUp,
      switchRootDown,
      switchRootUp,
    }) => {
      return {
        isSelected: selectedId === elementId,
        isActive: overElementId === elementId || selectedId === elementId,
        onOverElement: () => elementId !== overElementId ? overElement(elementId) : {},
        onLeaveElement: () => overElement(null),
        onSelectElement: () => selectElement(elementId !== selectedId ? elementId : null),
        toggleParents: (e) => {
          e.stopPropagation()
          if(elementId !== selectedId){
            selectElement(elementId)
          }
          return setShowParents(!showParents)
        },
        attachedParents: parents.map(({ id, refElement }) => ({
          id,
          refElement,
          onClick: (e) => {
            e.stopPropagation()
            return selectElement(id)
          },
        })),
        onDeleteElement: () => (
          parentId ?
            deleteElement(parentId, elementId)
            :
            deleteRootElement(elementId)
        ),
        onSwitchUp: () => (
          parentId ?
            switchUp(parentId, elementId)
            :
            switchRootUp(elementId)
        ),
        onSwitchDown: () => (
          parentId ?
            switchDown(parentId, elementId)
            :
            switchRootDown(elementId)
        )
      }
    },
  )
)


// WEBPACK FOOTER //
// ./src/store/canvas/hocsCanvas.js